import styled from "styled-components";
import { Button, ButtonGroup } from "reactstrap";

export const Container = styled.div`
  position: relative;
  margin: auto;
  text-align: center;
`;

export const Text = styled.p`
  position: relative;
  margin: auto;
`;

export const BootstrapButtonGroup = styled(ButtonGroup)`
  padding-bottom: 40px;
`;

export const BootstrapButton = styled(Button)`
  margin-top: 15px;
`;
